(function() {
  function fixMenuLinks() {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var targets = {
      'One Piece 海賊王商品': '/collections/one-piece-products-fu-ben',
      'Pokemon 寶可夢商品': '/collections/products-pokemon-%E5%AF%B6%E5%8F%AF%E5%A4%A2',
      '符文戰場商品': '/collections/riftbound-league-of-legends-fu-wen-zhan-chang-products-fu-ben'
    };

    document.querySelectorAll('a[href]').forEach(function(link) {
      var title = link.textContent.trim().replace(/\s+/g, ' ');
      if (targets[title]) link.setAttribute('href', targets[title]);

      var href = link.getAttribute('href');
      if (!href) return;
      try {
        var url = new URL(href, window.location.origin);
        if (isMobile && url.origin === window.location.origin && url.pathname === '/collections/op-op15') {
          link.setAttribute('href', '/collections/op-op15' + url.hash);
          return;
        }
        if (url.origin === window.location.origin && url.pathname === '/collections/op-op15' && !url.search) {
          link.setAttribute('href', '/collections/op-op15?page=1&sort_by=created-descending' + url.hash);
        }
        if (!isMobile && url.origin === window.location.origin && link.id === 'HeaderMenu-one-piece-海賊王-補充包單卡') {
          link.setAttribute('href', '/collections/op-op15?page=1&sort_by=created-descending');
        }
      } catch (error) {}
    });
  }

  function resizeShopifyImage(url, width) {
    if (!url || url.indexOf('/cdn/shop/') === -1) return url;
    if (url.indexOf('width=') !== -1) return url.replace(/width=\d+/g, 'width=' + width);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function imageKey(url) {
    return (url || '').replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '');
  }

  function fixHomePageMedia() {
    if (window.location.pathname !== '/') return;

    document.querySelectorAll('.cc-item').forEach(function(item, index) {
      var img = item.querySelector('img.cc-img');
      if (!img) return;
      img.setAttribute('src', resizeShopifyImage(img.getAttribute('src'), 1920));
      img.setAttribute('srcset', [
        resizeShopifyImage(img.getAttribute('src'), 960) + ' 960w',
        resizeShopifyImage(img.getAttribute('src'), 1440) + ' 1440w',
        resizeShopifyImage(img.getAttribute('src'), 1920) + ' 1920w'
      ].join(', '));
      img.setAttribute('sizes', '(max-width: 749px) 90vw, 60vw');
      img.setAttribute('decoding', 'async');
      img.setAttribute('loading', index === 0 ? 'eager' : 'lazy');
      img.setAttribute('fetchpriority', index === 0 ? 'high' : 'low');
    });

    var carouselFixStyle = document.getElementById('bgtcg-carousel-fit-fix');
    if (!carouselFixStyle) {
      carouselFixStyle = document.createElement('style');
      carouselFixStyle.id = 'bgtcg-carousel-fit-fix';
      carouselFixStyle.textContent = [
        '@media (min-width: 750px){',
        '.cc-wrap{overflow:hidden!important;}',
        '.cc-stage{aspect-ratio:16/6!important;}',
        '.cc-item.prev-item{opacity:.8!important;transform:translateX(calc(-50% - 60%)) translateY(-50%) rotateY(40deg) scale(.8)!important;}',
        '.cc-item.next-item{opacity:.8!important;transform:translateX(calc(-50% + 60%)) translateY(-50%) rotateY(-40deg) scale(.8)!important;}',
        '.cc-item{overflow:visible!important;}',
        '.cc-img{height:auto!important;max-height:none!important;}',
        '.cc-item.active{border:0!important;box-shadow:none!important;animation:none!important;}',
        '.cc-item.active .cc-img{border:2px solid #fff!important;border-radius:12px!important;box-shadow:0 0 4px #fff,0 0 10px #fff,0 0 25px #fff,0 0 50px #fff!important;animation:neon-pulse 2s ease-in-out infinite alternate!important;}',
        '}',
        '@media (max-width: 749px){',
        '.cc-wrap{overflow:hidden!important;}',
        '.cc-stage{aspect-ratio:16/9!important;overflow:hidden!important;}',
        '.cc-item{height:auto!important;}',
        '.cc-item.active{height:auto!important;width:90%!important;}',
        '.cc-img{height:auto!important;object-fit:contain!important;background:#000!important;}',
        '}'
      ].join('');
      document.head.appendChild(carouselFixStyle);
    }

    if (window.matchMedia('(min-width: 750px)').matches) {
      document.querySelectorAll('.cc-wrap').forEach(function(wrap) {
        wrap.style.setProperty('overflow', 'hidden', 'important');

        var stage = wrap.querySelector('.cc-stage');
        if (stage) {
          stage.style.setProperty('aspect-ratio', '16 / 6', 'important');
          stage.style.removeProperty('overflow');
        }

        wrap.querySelectorAll('.cc-item').forEach(function(item) {
          item.style.setProperty('width', '50%', 'important');
          item.style.setProperty('height', 'auto', 'important');
          item.style.setProperty('overflow', 'visible', 'important');
          item.style.removeProperty('aspect-ratio');
        });

        wrap.querySelectorAll('img.cc-img').forEach(function(img) {
          img.style.setProperty('height', 'auto', 'important');
          img.style.setProperty('max-height', 'none', 'important');
          img.style.setProperty('aspect-ratio', '16 / 9', 'important');
          img.style.setProperty('object-fit', 'contain', 'important');
          img.style.setProperty('background', '#000000', 'important');
        });
      });
    }

    document.querySelectorAll('.product-card-wrapper img').forEach(function(img, index) {
      if (index > 3) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('fetchpriority', 'low');
      }
      img.setAttribute('decoding', 'async');
    });
  }

  function applyProductBoxFrames(root) {
    root = root || document;

    function applyImageFitMode(img) {
      if (!img) return;

      function updateFitMode() {
        if (!img.naturalWidth || !img.naturalHeight) return;
        var ratio = img.naturalWidth / img.naturalHeight;
        var isFourFive = Math.abs(ratio - 0.8) <= 0.035;
        img.classList.toggle('bgtcg-img-45-fit', isFourFive);
        img.style.setProperty('object-fit', isFourFive ? 'cover' : 'contain', 'important');
        img.style.setProperty('padding', isFourFive ? '0' : '10px', 'important');
      }

      if (img.complete) {
        updateFitMode();
      } else {
        img.addEventListener('load', updateFitMode, { once: true });
      }
    }

    function frameItem(item) {
      if (!item) return;
      var wrapper = item.querySelector('.product-card-wrapper');
      if (!wrapper || !wrapper.classList.contains('bgtcg-non-single-card')) {
        item.classList.remove('bgtcg-product-box');
        item.dataset.bgtcgProductBoxApplied = 'false';
        var singleCard = item.querySelector('.product-card-wrapper .card');
        var singleInner = item.querySelector('.product-card-wrapper .card__inner');
        var singleMedia = item.querySelector('.product-card-wrapper .card__media .media');
        var singleImg = item.querySelector('.product-card-wrapper .card__media .media img');

        [singleCard, singleInner].forEach(function(el) {
          if (!el) return;
          el.style.removeProperty('--ratio-percent');
        });

        [singleInner, singleMedia, singleImg].forEach(function(el) {
          if (!el) return;
          el.style.removeProperty('background');
          el.style.removeProperty('border');
          el.style.removeProperty('box-sizing');
          el.style.removeProperty('overflow');
          el.style.removeProperty('inset');
          el.style.removeProperty('width');
          el.style.removeProperty('height');
          el.style.removeProperty('object-fit');
          el.style.removeProperty('object-position');
          el.style.removeProperty('padding');
        });
        if (singleImg) singleImg.classList.remove('bgtcg-img-45-fit');
        return;
      }

      item.dataset.bgtcgProductBoxApplied = 'true';
      item.classList.add('bgtcg-product-box');

      var card = item.querySelector('.product-card-wrapper .card');
      var inner = item.querySelector('.product-card-wrapper .card__inner');
      var media = item.querySelector('.product-card-wrapper .card__media .media');
      var img = item.querySelector('.product-card-wrapper .card__media .media img');

      [card, inner].forEach(function(el) {
        if (!el) return;
        el.style.setProperty('--ratio-percent', '125%', 'important');
      });

      if (inner) {
        inner.style.setProperty('background', '#ffffff', 'important');
        inner.style.setProperty('border', '1px solid rgba(247, 181, 0, 0.55)', 'important');
        inner.style.setProperty('box-sizing', 'border-box', 'important');
        inner.style.setProperty('overflow', 'hidden', 'important');
      }

      if (media) {
        media.style.setProperty('background', '#ffffff', 'important');
        media.style.setProperty('inset', '0', 'important');
        media.style.setProperty('width', '100%', 'important');
        media.style.setProperty('height', '100%', 'important');
      }

      if (img) {
        img.style.setProperty('width', '100%', 'important');
        img.style.setProperty('height', '100%', 'important');
        img.style.setProperty('object-position', 'center center', 'important');
        img.style.setProperty('box-sizing', 'border-box', 'important');
        applyImageFitMode(img);
      }
    }

    root.querySelectorAll('.rarity-section[data-rarity="其他"] .grid__item').forEach(frameItem);
    root.querySelectorAll('[id^="collection-"] .product-grid > .grid__item').forEach(frameItem);
  }

  fixMenuLinks();
  fixHomePageMedia();
  applyProductBoxFrames();
  setTimeout(applyProductBoxFrames, 300);
  setTimeout(applyProductBoxFrames, 1000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMenuLinks);
    document.addEventListener('DOMContentLoaded', fixHomePageMedia);
    document.addEventListener('DOMContentLoaded', function() {
      applyProductBoxFrames();
      setTimeout(applyProductBoxFrames, 300);
      setTimeout(applyProductBoxFrames, 1000);
    });
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) applyProductBoxFrames(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (!/\/(collections|search)(\/|$)/.test(window.location.pathname)) return;
  if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;

  var loading = false;
  var finished = false;
  var currentPage = Number(new URLSearchParams(window.location.search).get('page')) || 1;
  var gridContainer = document.querySelector('#ProductGridContainer');
  var pagination = document.querySelector('.pagination-wrapper');

  if (!gridContainer || !pagination) return;

  function getBaseRarityOrderForPage() {
    var pageText = [
      document.title,
      (document.querySelector('.collection-logo-banner') || {}).textContent,
      (document.querySelector('.op-sidebar__logo') || {}).textContent
    ].join(' ').toLowerCase();

    if (pageText.indexOf('pokemon') !== -1 || pageText.indexOf('寶可夢') !== -1 || pageText.indexOf('ptcg') !== -1) {
      return ['MUR', 'SAR', 'SR', 'AR', 'RR', 'R', 'U', 'C', 'UC'];
    }

    if (pageText.indexOf('gundam') !== -1 || pageText.indexOf('gcg') !== -1 || pageText.indexOf('高達') !== -1) {
      return ['LR', 'R', 'U', 'C'];
    }

    return [
      'P-SEC', 'P-SR', 'P-R', 'P-L', 'SP', 'SEC',
      'SR', 'R', 'UC', 'C', 'L', 'SAR', 'UR', 'SSR',
      'RR', 'Mythic', 'Rare', 'Uncommon', 'Common'
    ];
  }

  function isOnePiecePage() {
    var pageText = [
      window.location.pathname,
      document.title,
      (document.querySelector('.collection-logo-banner') || {}).textContent,
      (document.querySelector('.op-sidebar__logo') || {}).textContent
    ].join(' ').toLowerCase();

    return pageText.indexOf('one piece') !== -1 ||
      pageText.indexOf('海賊王') !== -1 ||
      pageText.indexOf('/collections/op-') !== -1 ||
      pageText.indexOf('op15') !== -1 ||
      pageText.indexOf('eb04') !== -1;
  }

  function normalizeOnePieceRarity(rarity, parts) {
    if (!isOnePiecePage()) return rarity;

    var value = String(rarity || '').trim();
    var lower = value.toLowerCase();
    if (
      value === '異圖卡' ||
      value === '漫畫異圖卡' ||
      value === '金' ||
      value === 'JP' ||
      lower === 'spカード'
    ) {
      value = parts && parts.length > 1 ? String(parts[parts.length - 2] || '').trim() : value;
    }

    if (value === 'P-SP' || value.indexOf('SPカード') !== -1) return 'SP';
    if (value === 'R 1') return 'R';
    return value;
  }

  var rarityOrder = getBaseRarityOrderForPage();
  var actualRarities = null;

  function rarityRank(rarity) {
    var index = rarityOrder.indexOf(rarity);
    return index === -1 ? 999 : index;
  }

  function createRarityButton(rarity) {
    var button = document.createElement('button');
    button.className = 'filter-btn';
    button.type = 'button';
    button.setAttribute('data-rarity', rarity);
    button.textContent = rarity;
    button.addEventListener('click', function() {
      if (typeof window.filterRarity === 'function') window.filterRarity(rarity, button);
    });
    return button;
  }

  function collectionProductsJsonUrl(page) {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path.indexOf('/collections/') !== 0) return null;
    return path + '/products.json?limit=250&page=' + page;
  }

  function rarityFromTitle(title) {
    var parts = String(title || '').split('|');
    if (parts.length < 2) return '';
    return normalizeOnePieceRarity(parts[parts.length - 1], parts);
  }

  function sortRarities(rarities) {
    return rarities.slice().sort(function(a, b) {
      return rarityRank(a) - rarityRank(b) || a.localeCompare(b);
    });
  }

  function facetRarityValues() {
    var rarityDetails = document.querySelector('details[id^="Details-filter.p.m.custom.rarity"]');
    if (!rarityDetails) return [];
    var seen = {};
    return Array.from(rarityDetails.querySelectorAll('input[name="filter.p.m.custom.rarity"]')).map(function(input) {
      return normalizeOnePieceRarity(input.value, null);
    }).filter(function(value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function applyRarityValues(values) {
    var baseOrder = getBaseRarityOrderForPage();
    var hasUnknownRarity = values.some(function(rarity) {
      return baseOrder.indexOf(rarity) === -1 && rarity !== '其他';
    });
    actualRarities = values.filter(function(rarity) {
      return baseOrder.indexOf(rarity) !== -1;
    });
    if (hasUnknownRarity) actualRarities.push('其他');
    rarityOrder = baseOrder.concat(['其他']);
    normalizeRarityControls();
  }

  function attachRarityButtonLoader(button) {
    if (button.dataset.rarityLoaderAttached === 'true') return;
    button.dataset.rarityLoaderAttached = 'true';
    button.addEventListener('click', function() {
      var rarity = button.getAttribute('data-rarity');
      if (!rarity || rarity === 'all') return;
      if (document.querySelector('.rarity-section[data-rarity="' + CSS.escape(rarity) + '"]')) return;
      loadUntilRarity(rarity);
    });
  }

  function refreshRarityOrderFromProducts(products) {
    var singleCards = products.filter(function(product) {
      return product.product_type === 'Single Card';
    });
    if (!products.length || singleCards.length / products.length < 0.8) {
      var filter = document.querySelector('#rarityFilterBtns');
      var group = filter && filter.closest('.filter-group');
      if (group) group.style.display = 'none';
      actualRarities = [];
      return;
    }

    var seen = {};
    var values = [];
    singleCards.forEach(function(product) {
      var rarity = rarityFromTitle(product.title);
      if (!rarity) rarity = '其他';
      if (!seen[rarity]) {
        seen[rarity] = true;
        values.push(rarity);
      }
    });
    applyRarityValues(values);
  }

  function fetchCollectionRarities() {
    var facetValues = facetRarityValues();
    if (facetValues.length && !isOnePiecePage()) {
      applyRarityValues(facetValues);
      return;
    }
    if (facetValues.length) applyRarityValues(facetValues);

    var firstUrl = collectionProductsJsonUrl(1);
    if (!firstUrl) return;

    fetch(firstUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Products JSON request failed');
        return response.json();
      })
      .then(function(payload) {
        var products = payload.products || [];
        refreshRarityOrderFromProducts(products);
      })
      .catch(function() {});
  }

  function normalizeRarityControls() {
    var group = document.querySelector('#rarityFilterBtns');
    if (!group) return;

    var activeRarity = (group.querySelector('button.active[data-rarity]') || {}).getAttribute && group.querySelector('button.active[data-rarity]').getAttribute('data-rarity');
    var targetRarities = actualRarities ? sortRarities(actualRarities) : rarityOrder;
    targetRarities.forEach(function(rarity) {
      if (rarity === '其他' && !group.querySelector('button[data-rarity="其他"]') && (!actualRarities || actualRarities.indexOf('其他') === -1)) return;
      if (!group.querySelector('button[data-rarity="' + rarity.replace(/"/g, '\\"') + '"]')) {
        group.appendChild(createRarityButton(rarity));
      }
    });

    var allButton = group.querySelector('button[data-rarity="all"]') || createRarityButton('all');
    if (!allButton.parentNode) {
      allButton.textContent = '全部';
      group.appendChild(allButton);
    }

    Array.from(group.querySelectorAll('button[data-rarity]')).forEach(function(button) {
      var value = button.getAttribute('data-rarity');
      var hasSection = Array.from(document.querySelectorAll('.rarity-section')).some(function(section) {
        return section.getAttribute('data-rarity') === value;
      });
      var isTargetRarity = targetRarities.indexOf(value) !== -1;
      if (value !== 'all' && !isTargetRarity && !hasSection) {
        if (button.getAttribute('data-rarity') === activeRarity) activeRarity = 'all';
        button.remove();
      }
    });

    var buttons = Array.from(group.querySelectorAll('button[data-rarity]'));
    buttons.sort(function(a, b) {
      var aValue = a.getAttribute('data-rarity');
      var bValue = b.getAttribute('data-rarity');
      if (aValue === 'all') return -1;
      if (bValue === 'all') return 1;
      return rarityRank(aValue) - rarityRank(bValue);
    });
    buttons.forEach(function(button) {
      group.appendChild(button);
      attachRarityButtonLoader(button);
      button.classList.toggle('active', button.getAttribute('data-rarity') === (activeRarity || 'all'));
    });
  }

  function getNextUrl(doc) {
    var nextLink = doc.querySelector('.pagination__item--prev[href]');
    if (nextLink) return new URL(nextLink.getAttribute('href'), window.location.href).toString();

    var fallbackUrl = new URL(window.location.href);
    fallbackUrl.searchParams.set('page', String(currentPage + 1));
    return fallbackUrl.toString();
  }

  function productKey(item) {
    var link = item.querySelector('a[href*="/products/"]');
    return item.id || (link && link.getAttribute('href')) || item.textContent.trim().slice(0, 120);
  }

  function ensureRarityButton(rarity) {
    var group = document.querySelector('#rarityFilterBtns');
    if (!group || !rarity) return;
    var buttonExists = Array.from(group.querySelectorAll('button[data-rarity]')).some(function(existing) {
      return existing.getAttribute('data-rarity') === rarity;
    });
    if (buttonExists) return;

    var button = createRarityButton(rarity);

    var buttons = Array.from(group.querySelectorAll('button[data-rarity]')).filter(function(existing) {
      return existing.getAttribute('data-rarity') !== 'all';
    });
    var beforeButton = buttons.find(function(existing) {
      return rarityRank(existing.getAttribute('data-rarity')) > rarityRank(rarity);
    });

    group.insertBefore(button, beforeButton || null);
    normalizeRarityControls();
  }

  function insertRaritySection(section) {
    var rarity = section.getAttribute('data-rarity');
    var sections = Array.from(gridContainer.querySelectorAll('.rarity-section'));
    var beforeSection = sections.find(function(existing) {
      return rarityRank(existing.getAttribute('data-rarity')) > rarityRank(rarity);
    });

    if (beforeSection) {
      beforeSection.before(section);
    } else {
      pagination.before(section);
    }
  }

  function stopLoading(observer) {
    finished = true;
    if (observer) observer.disconnect();
  }

  function loadMore(observer) {
    if (loading || finished) return Promise.resolve();

    var nextUrl = getNextUrl(document);
    if (!nextUrl) {
      stopLoading(observer);
      return Promise.resolve();
    }

    loading = true;

    return fetch(nextUrl)
      .then(function(res) {
        if (!res.ok) throw new Error('Pagination request failed');
        return res.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGridContainer = doc.querySelector('#ProductGridContainer');
        var nextPagination = doc.querySelector('.pagination-wrapper');

        if (!newGridContainer) {
          stopLoading(observer);
          return;
        }

        var existingKeys = new Set(Array.from(gridContainer.querySelectorAll('.grid__item')).map(productKey));
        var appended = 0;

        newGridContainer.querySelectorAll('.rarity-section').forEach(function(newSection) {
          var rarity = newSection.getAttribute('data-rarity');
          var currentSection = Array.from(gridContainer.querySelectorAll('.rarity-section')).find(function(section) {
            return section.getAttribute('data-rarity') === rarity;
          });
          var newItems = Array.from(newSection.querySelectorAll('.grid__item'));

          if (!currentSection) {
            var sectionClone = newSection.cloneNode(true);
            sectionClone.querySelectorAll('.grid__item').forEach(function(item) {
              var key = productKey(item);
              if (existingKeys.has(key)) {
                item.remove();
                return;
              }

              existingKeys.add(key);
              appended++;
            });

            if (sectionClone.querySelector('.grid__item')) {
              ensureRarityButton(rarity);
              insertRaritySection(sectionClone);
            }

            return;
          }

          var currentList = currentSection.querySelector('.product-grid, .collection-grid, [data-product-grid], ul.grid');
          if (!currentList) return;

          newItems.forEach(function(item) {
            var key = productKey(item);
            if (existingKeys.has(key)) return;

            existingKeys.add(key);
            currentList.appendChild(item.cloneNode(true));
            appended++;
          });

          var count = currentSection.querySelectorAll('.grid__item').length;
          var countEl = currentSection.querySelector('.rarity-count');
          if (countEl) countEl.textContent = '(' + count + ')';
        });

        if (nextPagination) {
          pagination.innerHTML = nextPagination.innerHTML;
          currentPage = Number(nextPagination.getAttribute('data-page')) || currentPage + 1;
        } else {
          pagination.remove();
          stopLoading(observer);
        }

        if (appended === 0 || !getNextUrl(document)) {
          stopLoading(observer);
        }
      })
      .catch(function() {
        stopLoading(observer);
      })
      .finally(function() {
        loading = false;
      });
  }

  function loadUntilRarity(rarity) {
    if (finished || document.querySelector('.rarity-section[data-rarity="' + CSS.escape(rarity) + '"]')) return;
    loadMore().then(function() {
      if (!finished && !document.querySelector('.rarity-section[data-rarity="' + CSS.escape(rarity) + '"]')) {
        window.setTimeout(function() {
          loadUntilRarity(rarity);
        }, 80);
      }
    });
  }

  function preloadRemainingPages() {
    if (finished) return;
    loadMore().then(function() {
      if (!finished) {
        window.setTimeout(preloadRemainingPages, 80);
      }
    });
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) {
        loadMore(observer);
      }
    }, { rootMargin: '300px 0px' });

    observer.observe(pagination);
  }

  window.addEventListener('scroll', function() {
    if (loading || finished) return;
    var scrollBottom = window.innerHeight + window.scrollY;
    var pageBottom = document.body.offsetHeight - 300;
    if (scrollBottom >= pageBottom) loadMore();
  }, { passive: true });

  normalizeRarityControls();
  fetchCollectionRarities();
  if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) {
    window.setTimeout(preloadRemainingPages, 120);
  }

})();
